import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NoteBoilerplatesCreateComponent } from './note-boilerplates-create.component';

import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from "@angular/material/input";
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [
    NoteBoilerplatesCreateComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,

    // material
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatDividerModule,
    MatButtonModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    DragDropModule,
  ],
  exports: [
    NoteBoilerplatesCreateComponent
  ]
})
export class NoteBoilerplateCreateModule { }
